module.exports = __webpack_public_path__ + "catalog/items/firesafety/Fire-Extinguisher-Wet-Chemical/Fire-Extinguisher-Wet-Chemical.svg";